const useGetUserData = () => {
  const localAuth = localStorage.getItem("auth");
  if (localAuth) {
    const auth = JSON.parse(localAuth);
    if (auth.accessToken && auth.user) {
      return auth.user;
    }
  }
};

export default useGetUserData;
